/** Public demo traffic is separate from application and acquisition analytics. */
export function isDemoPath(pathname: string) {
  return /^\/(?:es\/|en\/)?demo(?:\/|$)/.test(pathname);
}
export function opaqueDemoRef(value: string | null) {
  return value && /^[A-Za-z0-9_-]{1,120}$/.test(value) ? value : null;
}
export function demoHref(base: string, path: string, ref: string | null) {
  const url = new URL(path, 'https://demo.invalid');
  const route = url.pathname;
  const params = new URLSearchParams(url.search);
  if (route.startsWith('/app/conversations/')) {
    params.set('screen', 'conversations');
    params.set('conversation', route.slice('/app/conversations/'.length));
  } else {
    const screen =
      route === '/app' || route === '/app/'
        ? 'conversations'
        : route.replace(/^\/app\//, '').replace(/^\//, '');
    params.set('screen', screen === 'reports' ? 'reports/dashboard' : screen);
  }
  if (ref) params.set('ref', ref);
  return `${base}?${params}${url.hash}`;
}
